import { AppHeader } from '@/components/shared/AppHeader';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useContext } from 'react';
import { ApuracaoIbsCbsTab } from './apuracao-ibs-cbs';
import { ApuracaoIcmsTab } from './apuracao-icms';
import { ApuracaoCbsRtcTab } from './apuracao-cbs-rtc';
import { CalculadoraRtcTab } from './calculadora-rtc';
import { CreditosLc214Tab } from './creditos-lc214';
import { ResumoGeralTab } from './resumo-geral';
import { ApuracaoDetalhadaProvider } from '../ApuracaoDetalhadaProvider';
import { ApuracaoDetalhadaContext } from '@/contexts/ApuracaoDetalhadaContext';

export function ApuracaoDetalhadaPage() {
  return (
    <ApuracaoDetalhadaProvider>
      <ApuracaoDetalhadaPageInner />
    </ApuracaoDetalhadaProvider>
  );
}

function ApuracaoDetalhadaPageInner() {
  const ctx = useContext(ApuracaoDetalhadaContext);
  if (!ctx) {
    throw new Error(
      'ApuracaoDetalhadaPageInner deve ser usado dentro de <ApuracaoDetalhadaProvider>'
    );
  }
  const { handleBuscar, handleLimparFiltrosGlobais } = ctx;

  return (
    <div className="min-h-screen bg-background">
      <AppHeader
        title="Apuração Detalhada"
        subtitle="Resumo por CFOP, CST e Classificação Tributária"
        onBuscar={handleBuscar}
        onLimparFiltros={handleLimparFiltrosGlobais}
      />

      <main className="w-full px-6 py-8">
        <Tabs defaultValue="apuracao-ibs-cbs" className="space-y-6">
          <TabsList className="grid w-full grid-cols-6 mb-8">
            <TabsTrigger value="apuracao-ibs-cbs">Apuração de IBS e CBS</TabsTrigger>
            <TabsTrigger value="resumo-geral">Resumo Geral</TabsTrigger>
            <TabsTrigger value="creditos-lc214">Créditos LC 214/2025</TabsTrigger>
            <TabsTrigger value="apuracao-icms">Apuração ICMS (demonstração)</TabsTrigger>
            <TabsTrigger value="apuracao-cbs-rtc">Apuração assistida CBS</TabsTrigger>
            <TabsTrigger value="calculadora-rtc">Calculadora RTC</TabsTrigger>
          </TabsList>

          <ApuracaoIbsCbsTab />
          <ResumoGeralTab />
          <CreditosLc214Tab />
          <ApuracaoIcmsTab />
          <ApuracaoCbsRtcTab />
          <CalculadoraRtcTab />
        </Tabs>
      </main>
    </div>
  );
}
